export const EL_ATTR_CRUD_REQUEST = 'EL_ATTR_CRUD_REQUEST';
export const EL_ATTR_CRUD_SUCCESS = 'EL_ATTR_CRUD_SUCCESS';
export const EL_ATTR_CRUD_FAIL = 'EL_ATTR_CRUD_FAIL';
